import { z } from 'zod'

export const surveySearchSchema = z.object({
  search: z.string().max(200).optional().catch(undefined),
  status: z.enum(['all', 'active', 'inactive']).catch('all'),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.enum(['name', 'questionCount', 'internshipCount', 'active']).catch('name'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type SurveySearch = z.infer<typeof surveySearchSchema>

export const defaultSurveySearch: SurveySearch = {
  status: 'all',
  page: 1,
  pageSize: 10,
  sortBy: 'name',
  direction: 'asc',
}
